'use strict';

exports.__esModule = true;
exports.identify = identify;

var _Identifiers = require('../../types/Identifiers');

var _TagSchemas = require('../../types/TagSchemas');

var _validateTagStructure = require('../../tags/utils/validate-tag-structure');

/**
 * Tries to identify a tag and either returns identifier or `undefined`.
 *
 * @param {*} tag to identify.
 */
function identify(tag) {
  var ignoreList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!tag) {
    return undefined;
  }
  var identifierKeys = getFilteredIdentifierKeys(_Identifiers.IDENTIFIERS, ignoreList.concat(Object.keys(_Identifiers.TWITTER_TAGS)));

  return identifierKeys.find(function (identifier) {
    var schema = _TagSchemas.TAG_SCHEMAS[identifier];
    if (!schema) {
      return false;
    }

    return (0, _validateTagStructure.validateTagStructure)(tag, schema);
  });
}

function getFilteredIdentifierKeys(identifiers, ignoreList) {
  return Object.keys(identifiers).filter(function (identifierKey) {
    return !ignoreList.includes(identifierKey);
  });
}